import { gql } from '@apollo/client';

export const RESERVE_APPOINTMENT = gql`
  mutation ReserveAppointment(
    $serviceLocationId: String!
    $date: DateTime!
    $consultationType: ConsultationType!
    $consultationServiceServiceId: String!
  ) {
    reserveAppointment(
      data: {
        serviceLocationId: $serviceLocationId
        date: $date
        consultationType: $consultationType
        consultationServiceServiceId: $consultationServiceServiceId
      }
    ) {
      id
    }
  }
`;
